











import { State, Action } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    PagePresetGuest: () => import('@/layouts/presets/guest.vue'),
    FormBase: () => import('@/components/forms/Base.vue'),
    FormInput: () => import('@/components/forms/Input.vue'),
  },
})
export default class PageLogin extends Vue {
  @Action('user/login') login!: (payload: LoginPayload) => Promise<{}>;

  $refs!: Vue['$refs'] & {
    loginForm: FormClass;
  };

  payload: LoginPayload = {
    email: '',
    password: '',
  };

  private loginSubmit() {
    const $form: FormClass = this.$refs.loginForm;
    this.login(this.payload)
      .then(() => {
        $form.handleSuccess();
        this.$router.push({ name: 'products' });
      })
      .catch((e: ErrorResponse) => $form.handleErrors(e));
  }
}
